import { Badge } from "react-bootstrap";
import { FaFileExport } from "react-icons/fa";

import {
    ExportingState,
    STATE_CANCELLED,
    STATE_FAILED,
    STATE_OMITTED,
    STATE_RUNNING,
    STATE_SUCCEEDED,
} from "../../api/missionApi";

export function ExportInfoVariant(mission) {
    const state = ExportingState(mission);
    switch (state) {
        case STATE_CANCELLED:
            return "secondary";
        case STATE_OMITTED:
            return "secondary";
        case STATE_RUNNING:
            return "primary";
        case STATE_FAILED:
            return "danger";
        case STATE_SUCCEEDED:
            return "success";
        default:
            return "primary";
    }
}

export function ExportInfoString(mission) {
    const ignoreStates = [STATE_OMITTED];
    const doneStates = [STATE_CANCELLED, STATE_FAILED, STATE_SUCCEEDED];

    const states = Object.values(mission?.cloudExportStates || []).filter(
        (state) => !ignoreStates.includes(state),
    );
    const nrExportsToRun = states.length;
    const nrExportsDoneRunning = states.filter((state) =>
        doneStates.includes(state),
    )?.length;
    if (nrExportsToRun === nrExportsDoneRunning) {
        return <>{nrExportsToRun}</>;
    } else {
        return <>{`${nrExportsDoneRunning}/${nrExportsToRun}`}</>;
    }
}

export default function ExportInfoBadge(props) {
    return (
        <Badge pill bg={ExportInfoVariant(props.mission)} className="me-1">
            <FaFileExport className="me-2" style={{ marginTop: "-2px" }} />
            {ExportInfoString(props.mission)}
        </Badge>
    );
}
